<div class="response-view-container" [class.drawer-open]="drawer.isOpen()">
  @if (currentStickyHeader() && !onBoardingService.isTourActive()) {
    <div class="sticky-header-wrapper" #stickyHeaderRef>
      <div class="sticky-header">
        <div class="container-top-header">
          <div
            class="question"
            [class.question--expanded]="
              isQuestionExpanded('sticky-' + currentStickyHeader()?.index)
            "
          >
            <span
              class="body-large question-text"
              [class.question-text--collapsed]="
                !isQuestionExpanded('sticky-' + currentStickyHeader()?.index)
              "
            >
              {{ currentStickyHeader()?.answer }}
            </span>
            @if (isQuestionExpandable(currentStickyHeader()?.answer)) {
              <button
                type="button"
                data-fs-element="Open-Search-Response-Button-Toggle-Question-Sticky"
                mat-button
                class="question-toggle button-s right-button"
                (click)="toggleQuestionExpansion('sticky-' + currentStickyHeader()?.index)"
              >
                {{
                  (isQuestionExpanded('sticky-' + currentStickyHeader()?.index)
                    ? 'OPEN_SEARCH.SHOW_LESS'
                    : 'OPEN_SEARCH.SHOW_MORE'
                  ) | translate
                }}
                <mat-icon>
                  {{
                    isQuestionExpanded('sticky-' + currentStickyHeader()?.index)
                      ? 'keyboard_arrow_up'
                      : 'keyboard_arrow_down'
                  }}
                </mat-icon>
              </button>
            }
          </div>
          <img *ngIf="user()?.photo" class="avatar" [src]="user()?.photo" alt="User Photo" />
          <div *ngIf="!user()?.photo" class="avatar initials-avatar">
            {{ user()?.initials }}
          </div>
        </div>
      </div>
    </div>
  }
  <div class="response-content" #scrollContainer>
    @if (!showOnlyNewSearch() && errorDrawer() && !spinnerConversational() && !historyResponse()) {
      <app-error-not-found-404 [hideButton]="true"></app-error-not-found-404>
    }
    @if (showOnlyNewSearch() && !spinnerConversational() && !historyResponse()) {
      <app-new-search></app-new-search>
    }
    @if (historyResponse()) {
      <ng-container
        *ngFor="let responseDrawer of historyResponse()?.openQueryInteractions; let i = index"
      >
        <div
          class="container-responde"
          [class.active]="responseDrawer.isActive"
          [attr.data-index]="i"
        >
          @if (responseDrawer.question) {
            <div
              class="top-header"
              [attr.data-header-index]="i"
              [class.top-header--active]="responseDrawer.isActive"
            >
              <div class="container-top-header">
                <div
                  class="question"
                  [class.question--expanded]="
                    isQuestionExpanded(responseDrawer.question_id || 'idx-' + i)
                  "
                >
                  <span
                    class="body-large question-text"
                    [class.question-text--collapsed]="
                      !isQuestionExpanded(responseDrawer.question_id || 'idx-' + i)
                    "
                  >
                    {{ responseDrawer.question }}
                  </span>
                  @if (isQuestionExpandable(responseDrawer.question)) {
                    <button
                      type="button"
                      data-fs-element="Open-Search-Response-Button-Toggle-Question"
                      mat-button
                      class="question-toggle button-s right-button"
                      (click)="toggleQuestionExpansion(responseDrawer.question_id || 'idx-' + i)"
                    >
                      {{
                        (isQuestionExpanded(responseDrawer.question_id || 'idx-' + i)
                          ? 'OPEN_SEARCH.SHOW_LESS'
                          : 'OPEN_SEARCH.SHOW_MORE'
                        ) | translate
                      }}
                      <mat-icon iconPositionEnd class="icon icon-s">
                        {{
                          isQuestionExpanded(responseDrawer.question_id || 'idx-' + i)
                            ? 'keyboard_arrow_up'
                            : 'keyboard_arrow_down'
                        }}
                      </mat-icon>
                    </button>
                  }
                </div>
                <img *ngIf="user()?.photo" class="avatar" [src]="user()?.photo" alt="User Photo" />
                <div *ngIf="!user()?.photo" class="avatar initials-avatar">
                  {{ user()?.initials }}
                </div>
              </div>
            </div>
          }

          @if (responseDrawer.response === null) {
            <app-sadpath [type]="noLengthSadPath" />
          }

          @if (responseDrawer.response !== null && responseDrawer.response !== undefined) {
            <div class="container-resize" [id]="'response-' + responseDrawer.question_id">
              <div class="response-body">
                @if (isCuratedInteraction(responseDrawer)) {
                  <div
                    class="curated-response-mode-header"
                    [attr.aria-label]="'OPEN_SEARCH.CURATED_LESSONS_MODE' | translate"
                  >
                    <div class="curated-response-mode">
                      <mat-icon aria-hidden="true">query_stats</mat-icon>
                      <span>{{ 'OPEN_SEARCH.CURATED_LESSONS_MODE' | translate }}</span>
                    </div>
                  </div>
                }
                @if (hasSourcesForInteraction(responseDrawer) && responseDrawer.response !== '') {
                  <div class="response-type-operational">
                    <div class="response-text">
                      <div class="response-header">
                        <p
                          id="referenced-pages-button"
                          class="body-large markdown-body"
                          [innerHTML]="
                            responseDrawer.response
                              | markdownToPlainText: false : isCuratedInteraction(responseDrawer)
                          "
                        ></p>
                      </div>
                      @if (
                        isCuratedInteraction(responseDrawer) &&
                        curatedLessonsForInteraction(responseDrawer).length > 0
                      ) {
                        <ng-container
                          *ngTemplateOutlet="
                            curatedLessonsTemplate;
                            context: { interaction: responseDrawer }
                          "
                        ></ng-container>
                      }
                      <div class="footer-icons flex flex-justify-between mb-3">
                        <div class="flex icons">
                          <div id="feedback-buttons">
                            <button
                              [matTooltip]="'OPEN_SEARCH.THUMBS_UP' | translate"
                              mat-icon-button
                              class="icon-button-s"
                              data-fs-element="Open-Search-Button-Response-ThumbsUp"
                              [class.active]="
                                thumbStates()[responseDrawer.question_id || 'idx-' + i] === 'up'
                              "
                              (click)="toggleThumb('up', responseDrawer.question_id || 'idx-' + i)"
                            >
                              <mat-icon class="material-symbols-outlined">thumb_up</mat-icon>
                            </button>
                            <button
                              [matTooltip]="'OPEN_SEARCH.THUMBS_DOWN' | translate"
                              mat-icon-button
                              class="icon-button-s"
                              data-fs-element="Open-Search-Button-Response-ThumbsDown"
                              [class.active]="
                                thumbStates()[responseDrawer.question_id || 'idx-' + i] === 'down'
                              "
                              (click)="
                                toggleThumb('down', responseDrawer.question_id || 'idx-' + i)
                              "
                            >
                              <mat-icon class="material-symbols-outlined">thumb_down</mat-icon>
                            </button>
                          </div>
                          <div id="copy-answer-sources-button">
                            @let plainTextOperationals =
                              responseDrawer.response | markdownToPlainText: true;
                            <button
                              [matTooltip]="'OPEN_SEARCH.COPY' | translate"
                              mat-icon-button
                              class="icon-button-s"
                              data-fs-element="Open-Search-Button-Response-Copy"
                              appCopyData
                              [copiedType]="0"
                              [dataCopy]="[
                                plainTextOperationals,
                                'OPEN_SEARCH.OPERATIONAL_OVERVIEW' | translate,
                                mapCopySourcesOperationalsSummary(),
                                'OPEN_SEARCH.SOURCE_DETAILS' | translate,
                                mapCopyDocumentsOperationalsSummary(),
                                mapCopyCuratedLessonsSummary(),
                                'OPEN_SEARCH.CURATED_LESSON_SOURCES' | translate,
                                mapCopyCuratedLessonSourcesSummary(),
                              ]"
                            >
                              <mat-icon>content_copy</mat-icon>
                            </button>
                          </div>
                          <button
                            id="download-response-button"
                            data-fs-element="Open-Search-Response-Button-Download-With-Sources"
                            mat-icon-button
                            class="icon-button-s"
                            [matTooltip]="'OPEN_SEARCH.DOWNLOAD' | translate"
                            [matMenuTriggerFor]="downloadMenu"
                          >
                            <mat-icon>download</mat-icon>
                          </button>
                          <mat-menu id="download-response-menu" #downloadMenu="matMenu">
                            <button
                              mat-menu-item
                              data-fs-element="Open-Search-Button-Response-DownloadExcel"
                              (click)="exportResponseToExcel(i)"
                            >
                              <mat-icon>table_view</mat-icon>
                              <span>{{ 'OPEN_SEARCH.DOWNLOAD_EXCEL' | translate }}</span>
                            </button>
                            <button
                              mat-menu-item
                              data-fs-element="Open-Search-Button-Response-DownloadWord"
                              (click)="exportResponseToDoc(i)"
                            >
                              <mat-icon>description</mat-icon>
                              <span>{{ 'OPEN_SEARCH.DOWNLOAD_WORD' | translate }}</span>
                            </button>
                          </mat-menu>
                        </div>
                        <div
                          id="show-sources-overview-button"
                          class="open-source flex flex-justify-between flex-center"
                          data-fs-element="Open-Search-Button-Response-SourcesOverview"
                          (click)="openPanelSources()"
                        >
                          <mat-icon class="icon-container outline icon-xs cyan">link</mat-icon>
                          <p class="label-large semi-bold">
                            {{ 'KNOWLEDGE.PILLS_KNOWLEDGE.SOURCES_OVERVIEW' | translate }}
                          </p>
                          <mat-icon class="icon-s cyan">arrow_forward_ios</mat-icon>
                        </div>
                      </div>
                      <mat-divider class="pb-5"></mat-divider>
                    </div>
                  </div>
                }

                @if (!hasSourcesForInteraction(responseDrawer) && responseDrawer.response !== '') {
                  <div class="response-type-operational">
                    <div class="response-text">
                      <div class="response-header">
                        <p
                          class="body-large markdown-body"
                          [innerHTML]="
                            responseDrawer.response
                              | markdownToPlainText: false : isCuratedInteraction(responseDrawer)
                          "
                        ></p>
                      </div>
                      @if (
                        isCuratedInteraction(responseDrawer) &&
                        curatedLessonsForInteraction(responseDrawer).length > 0
                      ) {
                        <ng-container
                          *ngTemplateOutlet="
                            curatedLessonsTemplate;
                            context: { interaction: responseDrawer }
                          "
                        ></ng-container>
                      }
                      <div class="footer-icons flex flex-justify-between mb-3">
                        <div class="flex icons">
                          <div id="feedback-buttons">
                            <button
                              [matTooltip]="'OPEN_SEARCH.THUMBS_UP' | translate"
                              mat-icon-button
                              class="icon-button-s"
                              data-fs-element="Open-Search-Button-Response-ThumbsUp"
                              [class.active]="
                                thumbStates()[responseDrawer.question_id || 'idx-' + i] === 'up'
                              "
                              (click)="toggleThumb('up', responseDrawer.question_id || 'idx-' + i)"
                            >
                              <mat-icon class="material-symbols-outlined">thumb_up</mat-icon>
                            </button>
                            <button
                              [matTooltip]="'OPEN_SEARCH.THUMBS_DOWN' | translate"
                              mat-icon-button
                              class="icon-button-s"
                              data-fs-element="Open-Search-Button-Response-ThumbsDown"
                              [class.active]="
                                thumbStates()[responseDrawer.question_id || 'idx-' + i] === 'down'
                              "
                              (click)="
                                toggleThumb('down', responseDrawer.question_id || 'idx-' + i)
                              "
                            >
                              <mat-icon class="material-symbols-outlined">thumb_down</mat-icon>
                            </button>
                          </div>
                          <div id="copy-answer-sources-button">
                            @let plainTextOperationals =
                              responseDrawer.response | markdownToPlainText: true;
                            <button
                              [matTooltip]="'OPEN_SEARCH.COPY' | translate"
                              mat-icon-button
                              class="icon-button-s"
                              data-fs-element="Open-Search-Button-Response-Copy"
                              appCopyData
                              [copiedType]="0"
                              [dataCopy]="[
                                plainTextOperationals,
                                'OPEN_SEARCH.OPERATIONAL_OVERVIEW' | translate,
                                mapCopySourcesOperationalsSummary(),
                                'OPEN_SEARCH.SOURCE_DETAILS' | translate,
                                mapCopyDocumentsOperationalsSummary(),
                                mapCopyCuratedLessonsSummary(),
                                'OPEN_SEARCH.CURATED_LESSON_SOURCES' | translate,
                                mapCopyCuratedLessonSourcesSummary(),
                              ]"
                            >
                              <mat-icon>content_copy</mat-icon>
                            </button>
                          </div>
                          <button
                            id="download-response-button"
                            data-fs-element="Open-Search-Response-Button-Download-Without-Sources"
                            mat-icon-button
                            class="icon-button-s"
                            [matTooltip]="'OPEN_SEARCH.DOWNLOAD' | translate"
                            [matMenuTriggerFor]="downloadMenuNoSources"
                          >
                            <mat-icon>download</mat-icon>
                          </button>
                          <mat-menu
                            id="download-response-menu-no-sources"
                            #downloadMenuNoSources="matMenu"
                          >
                            <button
                              mat-menu-item
                              data-fs-element="Open-Search-Button-Response-DownloadExcel"
                              (click)="exportResponseToExcel(i)"
                            >
                              <mat-icon>table_view</mat-icon>
                              <span>{{ 'OPEN_SEARCH.DOWNLOAD_EXCEL' | translate }}</span>
                            </button>
                            <button
                              mat-menu-item
                              data-fs-element="Open-Search-Button-Response-DownloadWord"
                              (click)="exportResponseToDoc(i)"
                            >
                              <mat-icon>description</mat-icon>
                              <span>{{ 'OPEN_SEARCH.DOWNLOAD_WORD' | translate }}</span>
                            </button>
                          </mat-menu>
                        </div>
                      </div>
                      <mat-divider class="pb-5"></mat-divider>
                    </div>
                  </div>
                }

                @if (responseDrawer.response === '') {
                  <app-sadpath [type]="noTextSadPath" />
                }
              </div>
            </div>
          }
        </div>
      </ng-container>
    }
    <div class="container-resize">
      <div class="response-body">
        @if (spinnerConversational()) {
          <div class="top-header">
            <div class="container-top-header">
              <div class="question" [class.question--expanded]="isQuestionExpanded('prompt')">
                <span
                  class="body-large question-text"
                  [class.question-text--collapsed]="!isQuestionExpanded('prompt')"
                >
                  {{ promptText() }}
                </span>
                @if (isQuestionExpandable(promptText())) {
                  <button
                    type="button"
                    data-fs-element="Open-Search-Response-Button-Toggle-Question-Prompt"
                    mat-button
                    class="question-toggle button-s right-button"
                    (click)="toggleQuestionExpansion('prompt')"
                  >
                    {{
                      (isQuestionExpanded('prompt')
                        ? 'OPEN_SEARCH.SHOW_LESS'
                        : 'OPEN_SEARCH.SHOW_MORE'
                      ) | translate
                    }}
                    <mat-icon iconPositionEnd class="icon icon-s">
                      {{
                        isQuestionExpanded('prompt') ? 'keyboard_arrow_up' : 'keyboard_arrow_down'
                      }}
                    </mat-icon>
                  </button>
                }
              </div>
              <img *ngIf="user()?.photo" class="avatar" [src]="user()?.photo" alt="User Photo" />
              <div *ngIf="!user()?.photo" class="avatar initials-avatar">
                {{ user()?.initials }}
              </div>
            </div>
          </div>
          <div class="response-type-operational">
            <div class="response-text">
              <div class="response-header">
                <div>
                  <mat-icon fontIcon="analytics" class="icon-s response-icon outline"></mat-icon>
                </div>
                <div class="spinner-loading">
                  <mat-icon
                    fontIcon="progress_activity"
                    class="icon-s material-symbols-outlined spinner-rotate"
                  ></mat-icon>
                  <span>{{ 'SPINNER.OPEN_SEARCH' | translate }}</span>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </div>

  <ng-template #curatedLessonsTemplate let-interaction="interaction">
    <section class="curated-lessons" aria-labelledby="curated-lessons-title">
      <h3 id="curated-lessons-title" class="curated-lessons-title">
        {{ 'OPEN_SEARCH.CURATED_LESSONS_RELEVANT' | translate }}
      </h3>
      @for (
        item of showAllCuratedLessons()
          ? normalizedCuratedLessonsForInteraction(interaction)
          : normalizedCuratedLessonsForInteraction(interaction).slice(0, 1);
        track $index
      ) {
        <article class="curated-lesson-card">
          <h4 class="body-large-bold">
            {{ lessonValue(item.lesson, ['title', 'lessonName', 'name']) }}
            @if (lessonOperationCodes(item.lesson).length > 0) {
              ({{ lessonOperationCodes(item.lesson).join(', ') }})
            }
          </h4>
          @if (lessonParts(item.lesson); as parts) {
            <ul class="curated-lesson-points body-large">
              @if (parts.finding) {
                <li>{{ 'OPEN_SEARCH.LESSON_FINDING' | translate }}: {{ parts.finding }}</li>
              }
              @if (parts.recommendation) {
                <li>
                  {{ 'OPEN_SEARCH.LESSON_RECOMMENDATION' | translate }}: {{ parts.recommendation }}
                </li>
              }
            </ul>
          } @else {
            @if (lessonValue(item.lesson, ['finding', 'hallazgo']); as finding) {
              <p class="body-large">
                {{ 'OPEN_SEARCH.LESSON_FINDING' | translate }}: {{ finding }}
              </p>
            }
            @if (lessonValue(item.lesson, ['recommendation', 'recomendacion']); as recommendation) {
              <p class="body-large">
                {{ 'OPEN_SEARCH.LESSON_RECOMMENDATION' | translate }}: {{ recommendation }}
              </p>
            }
          }
          @for (source of item.sources; track source.reference) {
            <a
              class="curated-source-reference"
              [href]="source.url"
              target="_blank"
              rel="noopener noreferrer"
              [attr.aria-label]="source.fileName"
              (mouseenter)="setLessonSourceHover(source.url)"
              (mouseleave)="clearLessonSourceHover()"
            >
              [{{ source.reference }}]
            </a>
          }
        </article>
      }
      @if (curatedLessonsForInteraction(interaction).length > 1) {
        <button type="button" class="curated-lessons-toggle" (click)="toggleCuratedLessons()">
          {{
            (showAllCuratedLessons() ? 'OPEN_SEARCH.SHOW_LESS' : 'OPEN_SEARCH.RELATED_LESSONS')
              | translate: { count: curatedLessonsForInteraction(interaction).length - 1 }
          }}
          <mat-icon>
            {{ showAllCuratedLessons() ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
          </mat-icon>
        </button>
      }
    </section>
  </ng-template>
  <section>
    <section class="container">
      <div class="input-container">
        <app-textarea-search
          [(showAllResults)]="showAllResults"
          [(inputText)]="inputText"
          [(searchType)]="searchType"
          [(items)]="items"
          [(showResponseView)]="showResponseView"
          [(activeDestroyComponent)]="activeDestroyComponent"
          [(isComponentResponseView)]="isComponentResponseView"
          [(showSearchPanel)]="showSearchPanel"
          [(isShowAllResults)]="isShowAllResults"
          [(showOnlyNewSearch)]="showOnlyNewSearch"
          [(queryMode)]="queryMode"
        />
      </div>
      <p class="body-small italic mb-2 text-center mt-1">
        {{ 'OPEN_SEARCH.TITLE_FOTTER-SEARCH_RESPONSE' | translate }}
      </p>
    </section>
  </section>
</div>
